import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BrandFilterBody = _resolveComponent("BrandFilterBody");
  const _component_FilterItem = _resolveComponent("FilterItem");
  return _openBlock(), _createBlock(_component_FilterItem, {
    id: "brands",
    ref: "brandFilterItem",
    icon: "BuildingIcon",
    title: $options.getBrandTitle,
    class: "brand-filter",
    selectedTitle: $options.getBrandSelectedTitle,
    selectedCount: $props.brands?.filterState?.selectedCount,
    onClearAll: $options.handleClearAll,
    onApply: _cache[3] || (_cache[3] = $event => _ctx.$emit('apply')),
    onHidden: $options.onHidden
  }, {
    body: _withCtx(() => [_createVNode(_component_BrandFilterBody, {
      title: "Brand",
      selected: $props.brands?.filterState?.selected,
      isModified: $props.brands.isModified,
      pendingChanges: $props.brands.pendingChanges,
      isSearching: $props.brands.isSearching,
      keyword: $props.brands.keyword,
      list: $props.brands.displayList,
      onClear: $options.handleClear,
      onDiscard: $options.onDiscard,
      onRestoreSearch: $options.onRestoreSearch,
      onSelect: $options.handleSelect,
      onSelectOnly: $options.handleSelectOnly,
      onSelectAll: _cache[0] || (_cache[0] = $event => $props.brands.selectAll()),
      onDeselect: $options.handleDeselect,
      onApply: _cache[1] || (_cache[1] = $event => _ctx.$emit('apply')),
      onSearch: $options.handleBrandSearch,
      onHidden: $options.onHidden,
      onCloseDropdown: _cache[2] || (_cache[2] = $event => _ctx.$refs?.brandFilterItem?.closeDropdown())
    }, null, 8, ["selected", "isModified", "pendingChanges", "isSearching", "keyword", "list", "onClear", "onDiscard", "onRestoreSearch", "onSelect", "onSelectOnly", "onDeselect", "onSearch", "onHidden"])]),
    _: 1
  }, 8, ["title", "selectedTitle", "selectedCount", "onClearAll", "onHidden"]);
}